import React, { useContext, useState } from 'react'
import DefaultLayout from '../../components/layout/DefaultLayout'
import dummayimage from '../../assets/images/dummay/dummay.png';
import { useFormik } from 'formik';
import OtpField from '../../components/Form/OtpField';
import EmailField from '../../components/Form/EmailField';
import * as yup from 'yup';
import { emailValidation, passwordValidationsignup } from '../../utils/validation';
import PasswordFiled from '../../components/Form/PasswordField';
import ClipLoader from "react-spinners/ClipLoader";
import { restPasswordService } from '../../services/authServices';
import { rootContexts } from '../../contexts/rootContexts';
import errorModel from '../../components/Errors/ErrorModel';
export default function Verification() {

  const { setAsLogin } = useContext(rootContexts);
  const [loader, setLoader] = useState(false);
  const formik = useFormik({
    initialValues:{
      email:"",
      otp1:"",
      otp2:"",
      otp3:"",
      otp4:"",
      password:"",
      password_confirmation:"",
    },
    validationSchema: yup.object({
      email:emailValidation,
      password:passwordValidationsignup,
     
      password_confirmation:yup.string()
  .oneOf([yup.ref('password'), null], 'Passwords must match')
  .required('Please confirm your password')
      
    }),
    onSubmit: async (values) => {
      const code=`${values.otp1}${values.otp2}${values.otp3}${values.otp4}`;
      const val={
        email:values.email,
        password:values.password,
        password_confirmation:values.password_confirmation,
        code:code
      }
      const result = await restPasswordService(val)
  
      if(result.status){
        setLoader(false);
        errorModel('success',result.message)
        setAsLogin(true)
      }
      else{
        setLoader(false);
        errorModel('error',result.message)

      }
    }
  })
  return (
    <DefaultLayout>
      <div className=" ">
        <div className=" h-full overflow-hidden">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 h-full">
      <div className='py-10 pl-2 md:pl-20'>
        <h1 className='h1'>Verification</h1>
        <p className="p pt-4 md:pt-20 text-center">Lorem, ipsum dolor sit amet.</p>
        <div className="pt-5 ">
        <form onSubmit={formik.handleSubmit} className='space-y-4'>
            <EmailField
              label="Email"
              name="email"
              placeholder="Email"
              formik={formik}
              />
              <PasswordFiled
                label="Password"
                name="password"
                placeholder="Enter your password"
                formik={formik}
                />
              <PasswordFiled
                label="Confirm Password"
                name="password_confirmation"
                placeholder="Enter your Confirm password"
                formik={formik}
                />
              <label className="p">OTP Code</label>
            <div className="flex gap-x-4 items-center  py-2">
            <OtpField
                        label=""
                        name="otp1"
                        placeholder="0"
                        formik={formik}
                      />
            <OtpField
                        label=""
                        name="otp2"
                        placeholder="0"
                        formik={formik}
                      />
            <OtpField
                        label=""
                        name="otp3"
                        placeholder="0"
                        formik={formik}
                      />
            <OtpField
                        label=""
                        name="otp4"
                        placeholder="0"
                        formik={formik}
                      />
            </div>
        
                      <div className="py-1 flex items-center justify-center">
                      <button className='btn-primary'
                       disabled={loader}
                       
                      >
                Verify
                <ClipLoader
        color={"#ffffff"}
        loading={loader}
        // cssOverride={override}
        size={15}
        className="relative top-1 left-2"
        aria-label="Loading "
        data-testid="loader"
      />
              </button>
                      </div>
            
          </form>
        </div>
      </div>
      <div className=''>
        <img src={dummayimage} className="w-full h-full" alt="" />
      </div>
    </div>
        </div>
      </div>
   
    </DefaultLayout>
  )
}
